import { render, staticRenderFns } from "./hour-statistics.vue?vue&type=template&id=46cd595a&scoped=true"
import script from "./hour-statistics.vue?vue&type=script&lang=js"
export * from "./hour-statistics.vue?vue&type=script&lang=js"
import style0 from "./hour-statistics.vue?vue&type=style&index=0&id=46cd595a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd595a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46cd595a')) {
      api.createRecord('46cd595a', component.options)
    } else {
      api.reload('46cd595a', component.options)
    }
    module.hot.accept("./hour-statistics.vue?vue&type=template&id=46cd595a&scoped=true", function () {
      api.rerender('46cd595a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/hour-statistics.vue"
export default component.exports